/**
 * Scheduler Dashboard - Main Entry Point
 *
 * Dashboards for:
 * - Leadership: Capacity utilization, strategic planning
 * - Account Managers: Project status, delivery dates
 *
 * See DESIGN-SYSTEM.md for UI standards.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
